import axiosAuth from "../../axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetSafetyCheckUpdatesProps {
  projectId: string;
  taskId: string;
  checkId: string;
  includePresignedUrls?: boolean;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getSafetyCheckUpdates = async (taskId: string, projectId: string, checkId: string, includePresignedUrls: boolean = true) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/tasks/${taskId}/safety-checks/${checkId}/updates${includePresignedUrls ? `?includePresignedUrls=${includePresignedUrls}` : ''}`);

const useGetSafetyCheckUpdates = ({
  taskId,
  projectId,
  checkId,
  includePresignedUrls = true,
  queryParams,
}: UseGetSafetyCheckUpdatesProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["safety-checks-updates", checkId],
    queryFn: () => getSafetyCheckUpdates(taskId, projectId, checkId, includePresignedUrls),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetSafetyCheckUpdates;
